import { useFormContext } from "react-hook-form";
import UnForm from "../../../../../../Components/Form";
import { useUserInfor } from "../../../../../../Context/User";
import { MoneyReaisFieldMask } from "../../../../../../Validations/InputMasks";

interface IManutencaoECustosProps {
    preInputName?: string;
}

export default function ManutencaoECustos(props: IManutencaoECustosProps) {
    const { ConfigAssistenciaTecnicaDTO } = useUserInfor().Config;

    const { getValues } = useFormContext();
    return (
        <div>
            <div className="mb-4">
                <div className="row m-0">
                    <UnForm.Input
                        wrapperClassName="col-md-4"
                        label="Data de Reparo"
                        name={`${props.preInputName ?? ""}DT_REGISTRO`}
                        type={"date"}
                        registerOptions={{
                            required: "Insira a Data de Reparo",
                        }}
                    />
                    <UnForm.Input
                        name={`${props.preInputName ?? ""}HR_INICIO`}
                        wrapperClassName="col-md-4"
                        label="Hora Inicial"
                        type={"time"}
                        registerOptions={{
                            required: "Insira o Horário Inicial de Reparo",
                        }}
                    />
                    <UnForm.Input
                        name={`${props.preInputName ?? ""}HR_FIM`}
                        wrapperClassName="col-md-4"
                        label="Hora Final"
                        type={"time"}
                        registerOptions={{
                            required: "Insira o Horário Final de Reparo",
                            validate: {
                                positive: () => {
                                    const hrInicio1 = getValues(
                                        `${props.preInputName ?? ""}HR_INICIO`
                                    ).split(":")[0];
                                    const hrInicio2 = getValues(
                                        `${props.preInputName ?? ""}HR_INICIO`
                                    ).split(":")[1];

                                    const hrFim1 = getValues(
                                        `${props.preInputName ?? ""}HR_FIM`
                                    ).split(":")[0];
                                    const hrFim2 = getValues(
                                        `${props.preInputName ?? ""}HR_FIM`
                                    ).split(":")[1];

                                    const minutosTotalInicio =
                                        Number(hrInicio2) +
                                        Number(hrInicio1) * 60;
                                    const minutosTotalFim =
                                        Number(hrFim2) + Number(hrFim1) * 60;

                                    const validaHoras =
                                        minutosTotalFim - minutosTotalInicio;
                                    if (validaHoras > 0) {
                                        return true;
                                    } else {
                                        return "Horário Final Menor que Horário Inicial";
                                    }
                                },
                            },
                        }}
                    />
                </div>
            </div>

            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.Select
                        name={`${props.preInputName ?? ""}DS_RESPONSAVEL`}
                        label="Responsável"
                        wrapperClassName="col-12 col-md-6 m-0"
                        registerOptions={{
                            required: "Insira o Responsável Pelo Reparo",
                        }}
                    >
                        <option></option>
                        <option>Própria Empresa</option>
                        <option>Construtora</option>
                        <option>Cliente</option>
                    </UnForm.Select>
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""}DS_RESPONSAVEL_NOME`}
                        label="Nome"
                        noRezise
                        rows={1}
                        wrapperClassName="col-12 col-md-6 m-0"
                    />
                </div>
            </div>

            <div className="mb-4">
                <div className="row m-0">
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""}DS_SERVICO_REALIZADO`}
                        noRezise
                        rows={2}
                        label="Serviço Realizado:"
                        registerOptions={{
                            required: "Insira o serviço realizado:",
                        }}
                        wrapperClassName="col-12 col-md-6"
                    />
                    {ConfigAssistenciaTecnicaDTO.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO && (
                        <UnForm.Input
                            name={`${props.preInputName ?? ""
                                }VL_SERVICO_REALIZADO`}
                            label="Custo do Serviço:"
                            registerOptions={{
                                required: "Insira o Custo do Serviço:",
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            onChange={MoneyReaisFieldMask}
                        />
                    )}
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""}DS_EQUIPE_UTILIZADA`}
                        noRezise
                        rows={2}
                        label="Equipe Utilizada:"
                        registerOptions={{}}
                        wrapperClassName="col-12 col-md-6"
                    />
                    {ConfigAssistenciaTecnicaDTO.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO && (
                        <UnForm.Input
                            name={`${props.preInputName ?? ""
                                }VL_EQUIPE_UTILIZADA`}
                            label="Custo da Equipe:"
                            registerOptions={{
                                required: "Insira o Custo da Equipe:",
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            onChange={MoneyReaisFieldMask}
                        />
                    )}
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""
                            }DS_MATERIAL_UTILIZADO`}
                        noRezise
                        rows={2}
                        label="Material Utilizado:"
                        registerOptions={{}}
                        wrapperClassName="col-12 col-md-6"
                    />
                    {ConfigAssistenciaTecnicaDTO.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO && (
                        <UnForm.Input
                            name={`${props.preInputName ?? ""
                                }VL_MATERIAL_UTILIZADO`}
                            label="Custo do Material:"
                            registerOptions={{
                                required: "Insira o Custo do Material:",
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            onChange={MoneyReaisFieldMask}
                        />
                    )}
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""
                            }DS_EQUIPAMENTO_UTILIZADO`}
                        noRezise
                        rows={2}
                        label="Equipamento Utilizado:"
                        registerOptions={{}}
                        wrapperClassName="col-12 col-md-6"
                    />
                    {ConfigAssistenciaTecnicaDTO.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO && (
                        <UnForm.Input
                            name={`${props.preInputName ?? ""
                                }VL_EQUIPAMENTO_UTILIZADO`}
                            label="Custo do Equipamento:"
                            registerOptions={{
                                required: "Insira o Custo do Equipamento:",
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            onChange={MoneyReaisFieldMask}
                        />
                    )}
                    <UnForm.Textarea
                        name={`${props.preInputName ?? ""
                            }DS_DESLOCAMENTO_UTILIZADO`}
                        noRezise
                        rows={2}
                        label="Deslocamento Utilizado:	"
                        registerOptions={{}}
                        wrapperClassName="col-12 col-md-6"
                    />
                    {ConfigAssistenciaTecnicaDTO.FL_EXIBIR_CUSTOS_CONCLUIR_MANUTENCAO && (
                        <UnForm.Input
                            name={`${props.preInputName ?? "" ?? ""
                                }VL_DESLOCAMENTO_UTILIZADO`}
                            label="Custo do Deslocamento:"
                            registerOptions={{
                                required: "Insira o Custo do Deslocamento:",
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                            }}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            onChange={MoneyReaisFieldMask}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
